import React from 'react'
import SchoolList from '../../features/admin/SchoolList'

const SchoolListPage = () => {
  return (
    <SchoolList />
  )
}

export default SchoolListPage